import { render, staticRenderFns } from "./StepRulesTable.vue?vue&type=template&id=1dc70607&scoped=true&"
import script from "./StepRulesTable.vue?vue&type=script&lang=js&"
export * from "./StepRulesTable.vue?vue&type=script&lang=js&"
import style0 from "./StepRulesTable.vue?vue&type=style&index=0&id=1dc70607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc70607",
  null
  
)

export default component.exports